 <template>
  <div>
    <Menu />
    <RouteStepper :steps="steps"/>
    <GroupTablesComponent :timeline="filteredTimeline" :client="client" :refreshClient="refreshClient" :accountView="accountView" />
  </div>
</template>

<script>

import Menu from '@/components/Menu.vue'
import RouteStepper from '@/components/RouteStepper';
import GroupTablesComponent from'@/components/pagesComponents/client/GroupTablesComponent';
import viewMI from '@/mixins/viewMI.js'

export default {
    mixins: [viewMI],
    data() {
      return {
        timeline: [],
        client: {},
        accountView : true,
        steps: [
          {'name':'Clients',path: "/dashboard"},
        ],
        testingCode: "https://",
    }
    },

    components:{
          Menu,
          RouteStepper,
          GroupTablesComponent    
    },
    computed:{
      filteredTimeline(){
        return this.timeline.filter(tl => parseInt(tl.client_id) == parseInt(this.client.id))
      }
    },  
    methods: {
      userReady(){
        console.log('client')
        if (this.$store.state.user.user_type == 'account' || this.$store.state.user.user_type == 'administrator' )
          this.accountView = true;
        this.refreshClient();
        this.refreshTimeline();
       
      },
      refreshClient(){
        var _this = this;
        if (this.$store.state.user.user_type == 'client' ||  this.$store.state.user.user_type == 'account' || this.$store.state.user.user_type == 'administrator' )
        {
          this.get('client',{params: {
            where: [
              ['where','slug',_this.$route.params.client_slug]
            ],relations:1,
            relations_params:{
              brand: {
                relations: 1,
                
              }
            }
          }},function(resp){
            _this.client = resp.data.client[0];
            //console.log(_this.client)
            _this.steps = [
              {'name':'Clients',path: "/dashboard"},
            ],
            _this.steps.push({
              name: _this.client.name,path:'#'
            })
            //console.log(_this.steps);
            _this.$forceUpdate();
          })
        } else {

          _this.get('user_to_brand',
            {
              params: {
                where:[['where','user_id',this.$store.state.user.id]],
              }            
            },
            function(resp){
              
              var brand_ids = []
              for (var  i= 0; i < resp.data.user_to_brand.length; i++)
              {
                brand_ids.push(resp.data.user_to_brand[i].brand_id)
              }
              _this.get('client',{params: {
                where: [
                  ['where','slug',_this.$route.params.client_slug]
                ],relations:1,
                relations_params:{
                  brand: {
                    relations: 1,
                     where: [['where_in','id',brand_ids]],
                  }
                }
              }},function(resp){
                _this.client = resp.data.client[0];
                _this.refreshTimeline();
                //console.log(_this.client)
                _this.steps = [
                  {'name':'Clients',path: "/dashboard"},
                ],
                _this.steps.push({
                  name: _this.client.name,path:'#'
                })
                //console.log(_this.steps);
                _this.$forceUpdate();
              })
            })
          
        }
        
      },
        copyTestingCode () {
          let testingCodeToCopy = document.querySelector('#testing-code')
          testingCodeToCopy.setAttribute('type', 'text')    
          testingCodeToCopy.select()

          try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            alert('Testing code was copied ' + msg);
          } catch (err) {
            alert('Oops, unable to copy');
          }

          /* unselect the range */
          testingCodeToCopy.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()
        },
    },
    
}

</script>